import { TRACKING_BASE_URL } from "./constants";
import type { Claim } from "./types";

export const getTrackingUrl = (shipInsureId: string | null | undefined) => {
  if (!shipInsureId) {
    return null;
  }

  return `${TRACKING_BASE_URL}/${encodeURIComponent(shipInsureId)}`;
};

export const getClaimTrackingUrl = (claim: Claim) =>
  getTrackingUrl(claim.order?.ship_insure_id ?? claim.ship_insure_id);
